import getSingle from "./get-single.js";
import getMultiple from "./get-multiple.js";

export default {
	getSingle,
	getMultiple,
};
